import React from "react";

import {
	Grid,
	Stack,
	Typography
} from "@mui/material";
import { formatCurrency } from "../../../utils/utilityFunctions"
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

export default function LedgerSummaryStatistics(props) {

	const ledgerConfig = {
		ADVANCE: [
			{ label: "Total Funding", value: "totalFundedAmount" },
			{ label: "Total Net Funding", value: "totalNetFundedAmount", color: "gray" },
			{ label: "Total Recovery", value: "totalRecovery" },
			{ label: "Recovery Rate", value: "totalRecoveryRate", suffix: "%" },
			{ label: "Estimated Funding", value: "totalEstimatedFunding", color: "green" },
		],
		INCENTIVE_FEE_PAYABLE: [
			{ label: "Total Payable", value: "totalIncentivePayable" },
			// { label: "Total Incentive Debit", value: "totalIncentiveDebitAmount" },
			// { label: "Total Incentive Credit", value: "totalIncentiveCreditAmount" },
			// { label: "Total Incentive Balance", value: "totalIncentiveBalance" },
			// { label: "Total Incentive Disbursed", value: "totalIncentiveDisbursed" },
			// { label: "Incentive Disbursed Rate", value: "incentiveDisbursedRate", suffix: "%" },
			{ label: "Total Net Funding", value: "totalNetFundedAmount" },
			{ label: "Total Recovery", value: "totalRecovery" },
			{ label: "Recovery Rate", value: "totalRecoveryRate", suffix: "%" },
			{ label: "Estimated Funding", value: "totalEstimatedFunding", color: "green" },
		],
		AGENCY_FEE_PAYABLE: [
			{ label: "Total Agency Fee Payable", value: "totalAgencyPayable" },
			{ label: "Total Agency Disbursed", value: "totalAgencyDisbursed" },
			// { label: "Total Agency Debit", value: "totalAgencyDebitAmount" },
			// { label: "Total Agency Credit", value: "totalAgencyCreditAmount" },
			// { label: "Total Agency Balance", value: "totalAgencyBalance" },
			{ label: "Agency Disbursed Rate", value: "agencyDisbursedRate", suffix: "%" },
		],
	};

	// Chart configuration for KPI AD Ledger Graph Data
	const chartOptions = {
		chart: {
			type: 'column',
			height: 400
		},
		title: {
			text: 'Ledger Performance'
		},
		xAxis: {
			categories: props.ledgerStatistics?.kpiADLedgerGraphData?.map(item => item.consideredDate) || [],
			title: {
				text: 'Date'
			}
		},
		yAxis: {
			title: {
				text: 'Amount'
			}
		},
		legend: {
			layout: 'vertical',
			align: 'right',
			verticalAlign: 'middle'
		},
		series: [
			{
				name: 'Total Net Funding',
				data: props.ledgerStatistics?.kpiADLedgerGraphData?.map(item => item.totalNetFunding) || [],
				color: '#1565C0'
			}
		],
		responsive: {
			rules: [{
				condition: {
					maxWidth: 500
				},
				chartOptions: {
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom'
					}
				}
			}]
		}
	};

	return (
		<>
			<Grid container>
				<Grid item md={3} sm={6} xs={12}>
					<Stack spacing={2}>
						{ledgerConfig[props.selectedLedger]?.map((item, idx) => (
							<Stack
								key={idx}
								direction="row"
								spacing={4}
								alignItems="center"
								justifyContent="space-between"
							>
								<Typography variant="body2">{item.label}:</Typography>
								<Typography
									variant="h3"
									color={item.color || "inherit"}
								>
									{item.suffix === "%"
										? `${parseFloat(props.ledgerStatistics[item.value]).toFixed(2)} %`
										: formatCurrency(props.ledgerStatistics[item.value])}
								</Typography>
							</Stack>
						))}
					</Stack>
				</Grid>
				<Grid item md={2}>

				</Grid>
				<Grid item md={7} sm={6} xs={12}>
					{props.selectedLedger === "ADVANCE" && props.ledgerStatistics?.kpiADLedgerGraphData && (
						<HighchartsReact
							highcharts={Highcharts}
							options={chartOptions}
						/>
					)}
				</Grid>
			</Grid>
		</>
	)
}